import { HomePageConstants } from '../../_constants';
import { HomePageService } from '../../_services';

export const homePageAction = {
    addOrgHandler,
    getOrgHandler,
    getCountryListHandler,
}

//OrgAdmin ORG TEAM starts
function addOrgHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        HomePageService.addOrgHandler(data)
            .then(
                addOrg => {
                    dispatch(success(addOrg));
                    dispatch(getOrgHandler(() => { }))
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: HomePageConstants.REQUEST_ADD_ORG } }
    function success(addOrg) { return { type: HomePageConstants.RECEIVE_ADD_ORG, addOrg } }
    function failure(error) { return { type: HomePageConstants.ADD_ORG_ERROR, error } }
}

function getOrgHandler(callback) {
    return dispatch => {
        dispatch(request());
        HomePageService.getOrgHandler()
            .then(
                getOrg => {
                    dispatch(success(getOrg));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: HomePageConstants.REQUEST_GET_ORG } }
    function success(getOrg) { return { type: HomePageConstants.RECEIVE_GET_ORG, getOrg } }
    function failure(error) { return { type: HomePageConstants.GET_ORG_ERROR, error } }

}

function getCountryListHandler() {
    return dispatch => {
        dispatch(request());
        HomePageService.getCountryListHandler()
            .then(
                getCountryList => {
                    dispatch(success(getCountryList));
                    // callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: HomePageConstants.REQUEST_GET_COUNTRY_LIST } }
    function success(getCountryList) { return { type: HomePageConstants.RECEIVE_GET_COUNTRY_LIST, getCountryList } }
    function failure(error) { return { type: HomePageConstants.GET_COUNTRY_LIST_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/HomePage/homePage.action.js